var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app__start" }, [
    _c("div", {
      staticClass: "app__diamond app__diamond--top app__diamond--green"
    }),
    _vm._v(" "),
    _c("div", {
      staticClass: "app__start--content",
      domProps: { innerHTML: _vm._s(_vm.step.content) }
    }),
    _vm._v(" "),
    _c("div", {
      staticClass: "app__diamond app__diamond--bottom app__diamond--red"
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }